import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './FoldSummary.module.css';

import { motifPaths } from '../data/motifs.js'
import SiteBeacon from './SiteBeacon.js';
import Section from './ServiceSections.js';
import WhoAmI from './AboutMe.js';
import LandAcknowledgement from './LandAcknowledgement.js';
import { useInView } from 'react-intersection-observer';

import { duration } from '@mui/material/styles';
import EnvelopeContact from './EnvelopeContact.js';

const motifs = motifPaths;

//Hello! I’m Jon. I’m a graphic designer + illustrator with a background in games, UX and print. I’m passionate about the stories we tell through the experiences we create.

const servicesDescription =
    "Graphic Design · Book Illustration & Editorial Design · Wedding & Other Event Stationery · Marketing Collateral · Pre-Press · Large Format Signage · Digital Production · Responsible Web Design";

const showInterval = 100;
const hideInterval = 200;


function FoldSummary({ setBackToFooter = null }) {

    const [aboutOpen, setAboutOpen] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);
    const [contactOpen, setContactOpen] = useState(false);

    const [fadeAbout, setFadeAbout] = useState(true);
    const [fadeServices, setFadeServices] = useState(true);
    const [fadeContact, setFadeContact] = useState(true);

    const [pastFold, setPastFold] = useState(false);


    const {
        ref: pastFoldRef,
        inView: foldVisible }
        = useInView({
            threshold: 0.2,
            rootMargin: "0px",
            onChange: (inView, entry) => {
                if (inView) {
                    setPastFold(false);
                } else {
                    setPastFold(true);
                }
            }
        });



    function toggleAbout() {
        if (aboutOpen) {
            setFadeAbout(true);
            setTimeout(() => {
                setAboutOpen(!aboutOpen);
            }, hideInterval)
        } else {
            setAboutOpen(!aboutOpen);
            setTimeout(() => {
                setFadeAbout(false);
            }, showInterval)
        }
    }

    function toggleServices() {
        if (servicesOpen) {
            setFadeServices(true);
            setTimeout(() => {
                setServicesOpen(!servicesOpen);
            }, hideInterval)
        } else {
            setServicesOpen(!servicesOpen);
            setTimeout(() => {
                setFadeServices(false);
            }, showInterval)
        }
    }

    function toggleContact() {
        if (contactOpen) {
            setFadeContact(true);
            setTimeout(() => {
                setContactOpen(!contactOpen);
            }, hideInterval)
        } else {
            setContactOpen(!contactOpen);
            setTimeout(() => {
                setFadeContact(false);
            }, showInterval)
        }
    }



    function handleEnterSpacebar(event) {
        console.log(event.keyCode);
        if (event.keyCode === (13 || 32)) {
            if (event.target.id === "aboutToggle") {
                toggleAbout();
            } else if (event.target.id === "servicesToggle") {
                toggleServices();
            } else if (event.target.id === "contactToggle") {
                toggleContact();
            }
        }
    }



    

    return (

        <div className={styles.foldSummary + " " + (pastFold ? styles.coverUp : "")} ref={pastFoldRef}>
            <SiteBeacon />
            <EnvelopeContact/>
            {/*<div className={styles.summaryBelt}>
                <div className={styles.summaryItem}>
                    <div onClick={toggleAbout} tabIndex={0} id="aboutToggle" onKeyDown={handleEnterSpacebar} className={styles.summaryItemAccordion}>
                        <h3 className={styles.summaryItemTitle}>About</h3>
                        <div className={styles.summaryItemToggle}>{(aboutOpen ? "–" : "+")}</div>
                    </div>
                    <div className={styles.summaryItemContent + " " + styles.aboutSummary +
                        (aboutOpen ? " " + styles.summaryItemContentShow : " " + styles.summaryItemContentHide) +
                        (fadeAbout ? " " + styles.summaryItemContentFadeOut : " " + styles.summaryItemContentFadeIn)}>
                        Hello! I’m Jon. I’m a graphic designer + illustrator with a background in digital interaction design and print production.
                        <a href="#collaborate" className={styles.moreServicesLink}>working with me ⤳</a>

                    </div>
                </div>

                <div className={styles.summaryItem}>
                    <div onClick={toggleServices} id="servicesToggle" onKeyDown={handleEnterSpacebar} tabIndex={0} className={styles.summaryItemAccordion}>
                        <h3 className={styles.summaryItemTitle}>Services</h3>
                        <div className={styles.summaryItemToggle}>{(servicesOpen ? "–" : "+")}</div>
                    </div>
                    <div className={styles.summaryItemContent + " " + styles.servicesSummary +
                        (servicesOpen ? " " + styles.summaryItemContentShow : " " + styles.summaryItemContentHide) +
                        (fadeServices ? " " + styles.summaryItemContentFadeOut : " " + styles.summaryItemContentFadeIn)}>
                        {servicesDescription}
                        <a href="#services" className={styles.moreServicesLink}>+ more professional services</a>
                    </div>
                </div>

                <div className={styles.summaryItem}>
                    <div onClick={toggleContact} id="contactToggle" onKeyDown={handleEnterSpacebar} tabIndex={0} className={styles.summaryItemAccordion}>
                        <h3 className={styles.summaryItemTitle}>Contact</h3>
                        <div className={styles.summaryItemToggle}>{(contactOpen ? "–" : "+")}</div>
                    </div>
                    <div className={styles.summaryItemContent + " " + styles.contactSummary +
                        (contactOpen ? " " + styles.summaryItemContentShow : " " + styles.summaryItemContentHide) +
                        (fadeContact ? " " + styles.summaryItemContentFadeOut : " " + styles.summaryItemContentFadeIn)
                    }>
                        <a className={styles.contactSummaryButton} title="Send an email to design@jlliew.com" href="mailto:design@jlliew.com">Email me</a>
                        <p>design@jlliew.com</p>
                    </div>
                </div>
            </div>*/}
            <LandAcknowledgement />


        </div>

    );
}

export default FoldSummary;
